import { render, staticRenderFns } from "./AgreementLayout.vue?vue&type=template&id=137495b7&scoped=true&"
import script from "./AgreementLayout.vue?vue&type=script&lang=js&"
export * from "./AgreementLayout.vue?vue&type=script&lang=js&"
import style0 from "./AgreementLayout.vue?vue&type=style&index=0&id=137495b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137495b7",
  null
  
)

export default component.exports